<template>
	<div name="hres62e-entitlement-popup" id="hres62e-entitlement-popup" class="modal fade entitlement-popup" role="dialog">
		<div class="modal-dialog modal-lg">
		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['HRES62EC2']['15'] }}</h4>
		    </div>

		    <div class="modal-body">
					<div class="row">
						<div class="col-xs-12 col-md-3 entitlement-label">{{ labels['HRES62EC2']['300'] }}</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-calendar color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
						 {{ data.day1 }} <span class="unit">{{ labels['HRES62EC2']['270'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.hur1 }} <span class="unit">{{ labels['HRES62EC2']['280'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.min1 }} <span class="unit">{{ labels['HRES62EC2']['290'] }}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-md-3 entitlement-label">{{ labels['HRES62EC2']['310'] }}</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-calendar color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
						 {{ data.day2 }} <span class="unit">{{ labels['HRES62EC2']['270'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.hur2 }} <span class="unit">{{ labels['HRES62EC2']['280'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.min2 }} <span class="unit">{{ labels['HRES62EC2']['290'] }}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-md-3 entitlement-label">{{ labels['HRES62EC2']['320'] }}</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-calendar color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
						 {{ data.day3 }} <span class="unit">{{ labels['HRES62EC2']['270'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.hur3 }} <span class="unit">{{ labels['HRES62EC2']['280'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.min3 }} <span class="unit">{{ labels['HRES62EC2']['290'] }}</span>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-md-3 entitlement-label">{{ labels['HRES62EC2']['330'] }}</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-calendar color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
						 {{ data.day4 }} <span class="unit">{{ labels['HRES62EC2']['270'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.hur4 }} <span class="unit">{{ labels['HRES62EC2']['280'] }}</span>
						</div>
						<div class="col-xs-1 col-md-1 entitlement-icon"><i class="fa fa-clock-o color-skin" aria-hidden="true"></i></div>
						<div class="col-xs-3 col-md-2 entitlement-data">
							{{ data.min4 }} <span class="unit">{{ labels['HRES62EC2']['290'] }}</span>
						</div>
					</div>
				</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'hres62e-entitlement-popup',
  data () {
    return {
      selectedRow: []
    }
  },
  props: [ 'labels', 'data' ]
}
</script>

<style lang="scss">
  .entitlement-popup {
  	.modal-body {
  		padding-bottom: 30px;
  	}
    .row {
      margin: 0;
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #EBEBEB;

      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
      @media (max-width: 480px) {
				.col-xs-3 {
					width: auto;
				}
			}
    }
    .entitlement-label {
      font-family: 'promptlight';
      color: #707070;
			@media (max-width: 768px) {
				margin-bottom: 5px;
			}
    }
    .entitlement-icon {
      text-align: right;
      i {
        color: #3887c8;
        font-size: 14px;
      }
    }
    .entitlement-data {
      font-family: 'promptmedium';
      padding: 0 15px 0 0;
			@media (max-width: 768px) {
				padding: 0;
			}

      >.unit {
        padding: 0 0 0 5px;
				@media (max-width: 768px) {
					padding: 0;
				}
      }
    }
  }
</style>


// WEBPACK FOOTER //
// entitlementPopup.vue?0ebfb600